import { Injectable } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/observable/forkJoin';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import { TransactionHistoryModel, CustomerSearchFilterModel } from '@app/models/customer-transaction-history/TransactionHistoryModel';
import { TransactionHistoryEndpoint } from '@app/services/transactionHistory/transactionHistory-endpoint.service';
import { CustomerTxnReportSearch } from '../../models/customer-transaction-history/TransactionHistoryModel';
import { TransactionFilterModel, SearchFilterModel, FilterModel } from '@app/models/customer-transaction-history/Transaction-Filter-model';
import { MerchantProfileModel } from '@app/models/merchant-profile-model/merchant-profile-model';
import { CreditManagementModel, CreditManagementListModel, CreditPagingModel } from '@app/models/merchant/creditManagementModel';
import { ServiceRequestModel, HelpDeskModel } from '@app/models/merchant-settlement-model/merchant-settlement-model';
import { TerminalSearchInfo } from '@app/models/terminal/TerminalSearchInfoModel';
import { AcquirerOutlet } from '@app/models/merchant/AcquirerModel';
import { Paymentdetails } from '@app/models/merchant/merchantPaymentIndividualTransactionsModel';
import { TicketManagementModel } from '@app/models/ticketManagement/TicketManagementModel';

@Injectable()
export class TransactionHistoryService {
    constructor(private router: Router, private http: Http, private transactionhistoryEndpoint: TransactionHistoryEndpoint) {
    }

    getTransactionHistory(trans: TransactionFilterModel) {
      
        return this.transactionhistoryEndpoint.getTransactionHistory(trans);
    }

    getMerchantTxn(trans: TransactionFilterModel) {
      
        return this.transactionhistoryEndpoint.getMerchantTxn(trans);
    }
    getMerchantTxnPdfExcel(trans: TransactionFilterModel) {
      
        return this.transactionhistoryEndpoint.getMerchantTxnPdfExcel(trans);
    }

    getTransactionReportPdfExcel(trans: TransactionFilterModel) {
      
        return this.transactionhistoryEndpoint.getTransactionReportPdfExcel(trans);
    }

    getpatanajliTransactionHistory(data:CustomerTxnReportSearch) {
      
        return this.transactionhistoryEndpoint.getpatanajliTransactionHistory(data);
    }

    getPrePaidCreditCardHistory(data:CustomerSearchFilterModel) {
        return this.transactionhistoryEndpoint.getPrePaidCreditCardHistory(data);
    }

    updateData(customerId:number,LoadMoneyAmount:number,StatementPeriod: number){
        return this.transactionhistoryEndpoint.updateData(customerId,LoadMoneyAmount,StatementPeriod);
    }


    getTransactionHistoryDashboard(trans: TransactionFilterModel) {
        return this.transactionhistoryEndpoint.getTransactionHistoryDashboard(trans);
    }

    getMerchantDetails() {
      
        return this.transactionhistoryEndpoint.getMerchantDetails();
    }

    getMerchantTerminalNum(outletId:MerchantProfileModel) {
      
        return this.transactionhistoryEndpoint.getMerchantTerminalNum(outletId);
    }

    GetMerchantHierarchy(EntityValue:number) {
      
        return this.transactionhistoryEndpoint.GetMerchantHierarchy(EntityValue);
    }

    getMerchantOutlet(filtermodel:FilterModel) {
      
        return this.transactionhistoryEndpoint.getMerchantOutlet(filtermodel);
    }

    getMerchantTxnSummary(trans: TransactionFilterModel) {
        return this.transactionhistoryEndpoint.getMerchantTxnSummary(trans);
    }

    getMerchantOutletTxn(trans: TransactionFilterModel) {
        return this.transactionhistoryEndpoint.getMerchantOutletTxn(trans);
    }

    getMerchantOutletTxnPdfExcel(trans: TransactionFilterModel) {
        return this.transactionhistoryEndpoint.getMerchantOutletTxnPdfExcel(trans);
    }

    getMerchantSummary(trans: TransactionFilterModel) {
        return this.transactionhistoryEndpoint.getMerchantSummary(trans);
    }

    getAcquirerOutlet(outletInfo:AcquirerOutlet) {
      
        return this.transactionhistoryEndpoint.getAcquirerOutlet(outletInfo);
    }

    getOutletDetailsById(OutletId:number) {
      
        return this.transactionhistoryEndpoint.getOutletDetailsById(OutletId);
    }

    getTerminalDetailsById(OutletId:number) {
      
        return this.transactionhistoryEndpoint.getTerminalDetailsById(OutletId);
    }
    
    getAcquirerTerminal(terminalInfo:TerminalSearchInfo) {
        return this.transactionhistoryEndpoint.getAcquirerTerminal(terminalInfo);
    }

    getCustomerList(customerCode:CreditPagingModel) {
        return this.transactionhistoryEndpoint.getCustomerList(customerCode);
    }

    searchCustomer(customerCode:CreditManagementModel) {
        return this.transactionhistoryEndpoint.searchCustomer(customerCode);
    }

    updateCustomerLimit(customerLimit:CreditManagementModel) {
        return this.transactionhistoryEndpoint.updateCustomerLimit(customerLimit);
    }

    getTxnDetails(searchFilter: SearchFilterModel) {
      
        return this.transactionhistoryEndpoint.getTxnDetails(searchFilter);
    }
    getTxnStatusWiseCountDetails(searchFilter: SearchFilterModel) {
      
        return this.transactionhistoryEndpoint.getTxnStatusWiseCountDetails(searchFilter);
    }
    getSettlementDetails(trans: TransactionFilterModel) {
      
        return this.transactionhistoryEndpoint.getSettlementDetails(trans);
    }
    showMerchantSummaryDatewise(trans: TransactionFilterModel) {
      
        return this.transactionhistoryEndpoint.showMerchantSummaryDatewise(trans);
    }

    showMerchantSummaryIndividual(trans: TransactionFilterModel) {
      
        return this.transactionhistoryEndpoint.showMerchantSummaryIndividual(trans);
    }

    getSettlementDetailsPfdExcel(trans: TransactionFilterModel) {
      
        return this.transactionhistoryEndpoint.getSettlementDetailsPfdExcel(trans);
    }

    getBillingSettlement(trans:TransactionFilterModel) {
      
        return this.transactionhistoryEndpoint.getBillingSettlement(trans);
    }

    getBillingRequest(trans: TransactionFilterModel) {
      
        return this.transactionhistoryEndpoint.getBillingRequest(trans);
    }

    submitServiceRequest(serviceRequestModel: ServiceRequestModel) {
      
        return this.transactionhistoryEndpoint.submitServiceRequest(serviceRequestModel);
    }

    getIssueType() {
      
        return this.transactionhistoryEndpoint.getIssueType();
    }

    getIssueDetails() {
      
        return this.transactionhistoryEndpoint.getIssueDetails();
    }
    GetZonalMerchantData() {
      
        return this.transactionhistoryEndpoint.GetZonalMerchantData();
    }
    GetRegionalMerchantData(ParentMerchantId:number) {
      
        return this.transactionhistoryEndpoint.GetRegionalMerchantData(ParentMerchantId);
    }
    getLocationData(LocationTypeId:number,ParentMerchantId:number) {
      
        return this.transactionhistoryEndpoint.getLocationData(LocationTypeId,ParentMerchantId);
    }

    getPaymentDetailsDayWise(paymentdetails : Paymentdetails)
    {
        return this.transactionhistoryEndpoint.getPaymentDetailsDayWise(paymentdetails);
    }

    unsubscribeDashboardReport(id:string) {
      
        return this.transactionhistoryEndpoint.unsubscribeDashboardReport(id);
    }

    subscribeDashboardReport(id:string) {
      
        return this.transactionhistoryEndpoint.subscribeDashboardReport(id);
    }
    saveDashboardReport(id:string) {
      
        return this.transactionhistoryEndpoint.saveDashboardReport(id);
    }
    getRaiseTicketList(ticketManagementModel:TicketManagementModel){
        return this.transactionhistoryEndpoint.getRaiseTicketList(ticketManagementModel);
    }
    getDetailsForRaiseTicket(data:TicketManagementModel){
        return this.transactionhistoryEndpoint.getDetailsForRaiseTicket(data);
    }
    GetTerminalListOnMerchantId(merchantId:number){
        return this.transactionhistoryEndpoint.GetTerminalListOnMerchantId(merchantId);
    }
    GetTerminalListOnMerchantIdNew(merchantId:number){
        return this.transactionhistoryEndpoint.GetTerminalListOnMerchantIdNew(merchantId);
    }
    SaveRaisedTicketData(ticketManagementModel:TicketManagementModel){
        return this.transactionhistoryEndpoint.SaveRaisedTicketData(ticketManagementModel);
    }
    getTerminalByOutletCode(outletId:number){
        return this.transactionhistoryEndpoint.getTerminalByOutletCode(outletId);
    }

    getIssuerType() {
      
        return this.transactionhistoryEndpoint.getIssuerType();
    }

    getIssuerStatus() {
      
        return this.transactionhistoryEndpoint.getIssuerStatus();
    }

    getTicketType() {
      
        return this.transactionhistoryEndpoint.getTicketType();
    }

    getIssuerDetails(trans: HelpDeskModel) {
      // debugger
        return this.transactionhistoryEndpoint.getIssuerDetails(trans);
    }

    getTicketCount(data: HelpDeskModel) {
      
        return this.transactionhistoryEndpoint.getTicketCount(data);
    }

    getOpenTicketDetails(trans: HelpDeskModel) {
      
        return this.transactionhistoryEndpoint.getOpenTicketDetails(trans);
    }

    getCloseTicketDetails(trans: HelpDeskModel) {
      
        return this.transactionhistoryEndpoint.getCloseTicketDetails(trans);
    }

    getInProgressTicketDetails(trans: HelpDeskModel) {
      
        return this.transactionhistoryEndpoint.getInProgressTicketDetails(trans);
    }

    getIssuerDetailData(trans: HelpDeskModel) {
      
        return this.transactionhistoryEndpoint.getIssuerDetailData(trans);
    }

    getIssuerGridDetailData(trans: HelpDeskModel) {
      
        return this.transactionhistoryEndpoint.getIssuerGridDetailData(trans);
    }

    saveTicketMgmtData(trans: HelpDeskModel) {
      
        return this.transactionhistoryEndpoint.saveTicketMgmtData(trans);
    }
    fileUpload(formData: FormData,id:number) {
        return this.transactionhistoryEndpoint.fileUpload(formData,id);
    }

    getAccessTypeList(){
        return this.transactionhistoryEndpoint.getAccessTypeList();
    }

    getMerchantTxnDetailsSummary(searchFilter: CustomerTxnReportSearch) {
      
        return this.transactionhistoryEndpoint.getMerchantTxnDetailsSummary(searchFilter);
    }

    getMerchantTxnSummaryList(searchFilterData: CustomerTxnReportSearch)
    {
        return this.transactionhistoryEndpoint.getMerchantTxnSummaryList(searchFilterData);
    }
    
}


// WEBPACK FOOTER //
// ./src/app/services/transactionHistory/transactionHistory.service.ts